import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Grid from '@material-ui/core/Grid'
import Icon from '@material-ui/core/Icon'
const styles = theme => ({
  formControl: {
    margin: `0 ${theme.spacing.unit}px`,
    minWidth: 140
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    spacing: 8
  },
  iconEnabled: {
    marginRight: theme.spacing.unit,
    color: theme.palette.primary.main + '!important'
  },
  iconDisabled: {
    marginRight: theme.spacing.unit,
    color: theme.palette.action.disabled + '!important'
  }
})

export default withStyles(styles)(
  class NavigationConfigurationComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      updateNavigationMenu: PropTypes.func.isRequired,
      menu: PropTypes.array
    }
    state = {
      tab: 0
    }
    static defaultProps = {
      menu: [
        {
          index: 0,
          label: 'Home',
          show: true,
          iconName: 'home',
          route: '/home',
          sub: ['/table', '/bar']
        },
        {
          index: 1,
          label: 'Produits',
          show: true,
          iconName: 'local_bar',
          route: '/products',
          sub: []
        },
        {
          index: 2,
          label: 'Casiers',
          show: true,
          iconName: 'lock',
          route: '/lockers',
          sub: []
        },
        {
          index: 3,
          label: 'Clients',
          show: true,
          iconName: 'contacts',
          route: '/customers',
          sub: []
        },
        {
          index: 4,
          label: 'Historique',
          show: true,
          iconName: 'history',
          route: '/history',
          sub: []
        }
      ]
    }
    handleTabChange = (event, value) => {
      this.setState({ tab: value })
    }
    handleChange = index => event => {
      // this.props.handleChange({...this.state, [name] : event.target.checked})
      // this.setState({[name] : event.target.checked})
      this.props.updateNavigationMenu(index, event.target.checked)
    }
    getFormComponents = menu => {
      const { classes } = this.props
      return menu.map(m => (
        <Grid key={m.index} item xs={10} sm={8} md={6}>
          <FormControlLabel
            disabled={![2, 3].includes(m.index)}
            className={classes.formControl}
            control={
              <Switch
                checked={m.show}
                onChange={this.handleChange(m.index)}
                value={m.label}
                color="primary"
              />
            }
            label={
              <div className={classes.labelContainer}>
                <Icon
                  className={
                    m.show ? classes.iconEnabled : classes.iconDisabled
                  }>
                  {m.iconName}
                </Icon>
                {m.label}
              </div>
            }
          />
        </Grid>
      ))
    }
    render() {
      const { menu } = this.props
      return (
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="stretch"
          alignContent="stretch"
          spacing={24}>
          <Grid item xs={10} sm={8} md={12}>
            <Typography variant="subheading">
              Choisissez les élements que vous voulez utiliser{' '}
            </Typography>
            <Typography variant="caption">
              Vous pourrez les remettre par la suite{' '}
            </Typography>
          </Grid>
          <Grid item xs={10} sm={8} md={12}>
            <Divider light />
          </Grid>
          {this.getFormComponents(menu).map(comp => comp)}
          <Grid item xs={10} sm={8} md={12}>
            <Typography variant="body1">Prévisualisation :</Typography>
          </Grid>
          <Grid item xs={10} sm={8} md={12}>
            <Tabs
              value={this.state.tab}
              onChange={this.handleTabChange}
              indicatorColor="secondary"
              textColor="inherit"
              centered>
              {menu.filter(m => m.show).map(item => {
                return (
                  <Tab
                    key={item.index}
                    label={item.label}
                    icon={<Icon>{item.iconName}</Icon>}
                  />
                )
              })}
            </Tabs>
          </Grid>
        </Grid>
      )
      // return
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/DashpoolConfiguration/NavigationConfigurationComponent.js